import { defineMessages } from 'react-intl';

const messages = defineMessages({
  EmailContentRequired: 'The email must have content.',
  MsgEmailAttachmentUploadFailed: 'An error occurred when uploading the email attachment',
  NoEmailTemplateFoundInLanguage: 'No email template was found in {language}',
  SendEmail: 'Send email',
  Placeholders: 'Placeholders',
  Template: 'Template',
  NoTemplatesFound: 'No templates found',
  ChooseTemplate: 'Choose template',
  OpenEmailTemplates: 'Open email templates',
  Templates: 'Templates',
  PlaceholdersWillBeResolvedByAdminPulse: 'The visible placeholders will be resolved by AdminPulse',
  ClickHereToCreateFreeTextEmail:
    'Choose a template or click here to start typing an email without template.',
  UseThesePlaceholdersInYourEmail: 'Use these placeholders in your e-mail.',
  SendMailMakeSureAllFieldsAreFilledOut:
    'Email cannot be sent. Please make sure all emails in all languages have a subject and body',
  SendTo: 'To',
  AddEmailAddress: 'Add email address',
  RemoveEmailAddress: 'Remove email address',
  Cc: 'CC',
  Bcc: 'BCC',
  msgInvalidEmailAddress: 'Invalid email address',
  SubjectBodyRecipientsAreRequired: 'Subject, body and recipients are required.',
  msgTemplateNotInLanguage: 'Template not available in language of relation.',
  templateNotFound: 'The e-mail template could not be found',
  templateNotFoundCheckTaskTemplate:
    'The e-mail template could not be found. Please double check the task template to see if the correct e-mail template is configured.',
  AddEmployeeEmailAddress: 'Add employee email address',
  SelectOrTypeEmailAddress: 'Select or type an e-mail address',
  SelectEmailAddress: 'Select an e-mail address',
  DocumentsOfTheFollowingTypeWillBeLinkedIfPresent:
    'Documents of the following type will be attached to the email if linked to task:',
  EmailSent: 'Email sent',
  Forward: 'Forward',
  Relation: 'Relation',
  Reply: 'Reply',
  Search: 'Search',
  SelectRelationToRetrieveAddresses: 'Select a relation to retrieve addresses',
});
export default messages;
